<div class="closeLightbox" (click)="close()">
  <ngx-icon [icon]="'CLOSE_THIN'" [color]="'white'" [rotateHover]="true"></ngx-icon>
</div>
<img *ngIf="src != undefined" [src]="src" [alt]="" style="max-width: 90%; max-height: 90%">
